import React, { useEffect, useState, useRef } from "react";
import PageTitle from "../components/PageTitle";
import Index from "../view/Signup/Index";
import { validateAll } from "indicative/validator";
import ToastAlert from "../common/ToastAlert";
// import IntlTelInput from 'intl-tel-input';
// import "intl-tel-input/styles";
// import utils from 'https://cdn.jsdelivr.net/npm/intl-tel-input@19.1.0/build/js/utils.js';
// import utils from '../assest/js/intlUtils';
import ApiCall from "../common/ApiCall";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setEmailVerified, setLoading, setLogin } from "../redux/user/user.action";
import { CountrySelectoptions, DefaultSelectedCountrySelectoption } from "../common/Helper";
import { countries } from "../common/Config";

export default function SignupController() {

    const [state, setState] = useState({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        cpassword: "",
        recaptchaToken: "",
        legal_company_name: "",
        other_provider_name: "",
        error: [],
    })
    const { first_name, last_name, email, password, cpassword, recaptchaToken, legal_company_name, other_provider_name } = state;

    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSamePass, setIsSamePass] = useState(false);
    const inputRef = useRef(null);
    const [strength, setStrength] = useState(0);
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [initialCountry, setInitialCountry] = useState("pt");
    const [countryOptions, setCountryOptions] = useState(CountrySelectoptions);
    const [selectedCountryOption, setSelectedCountryOption] = useState('PT');
    const [selectedTourProviderOption, setSelectedTourProviderOption] = useState('');
    const [isLoadingCountry, setIsLoadingCountry] = useState(false);
    // let iti = null;
    // const itiRef = useRef(null); 

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const checkStrength = (password) => {
        let score = 0;

        if (password.length >= 8) score++; // Length
        if (/[A-Z]/.test(password)) score++; // Uppercase letter
        if (/[a-z]/.test(password)) score++; // Lowercase letter
        if (/[0-9]/.test(password)) score++; // Number
        if (/[^A-Za-z0-9]/.test(password)) score++; // Special character

        // 2 Method

        // if (password.match(/[a-z]+/)) {
        //     score += 1;
        //   }
        //   if (password.match(/[A-Z]+/)) {
        //     score += 1;
        //   }
        //   if (password.match(/[0-9]+/)) {
        //     score += 1;
        //   }
        //   if (password.match(/[$@#&!]+/)) {
        //     score += 1;
        //   }

        setStrength(score);
    };

    const getClassNames = (index) => {
        if (password.length === 0) {
            return 'comSpan';
        }

        const classNames = ['comSpan'];

        if (strength >= 1) {
            classNames[0] = 'comSpan redSpan';
        }
        if (strength >= 2) {
            classNames[1] = 'comSpan yellowSpan';
        }
        if (strength >= 3) {
            classNames[2] = 'comSpan greenSpan';
        }
        return classNames[index] || 'comSpan';
    };

    const isOtherProvider = selectedTourProviderOption === 'Other';
    const isNoProvider = selectedTourProviderOption === "I don't have a tour booking provider";

    const register = (e) => {
        e?.preventDefault();

        if (isLoading) {
            return;
        }


        const rules = {
            email: 'required|email',
            first_name: 'required',
            last_name: 'required',
            legal_company_name: 'required',
            ...(isOtherProvider ? { other_provider_name: 'required' } : {
                password: 'required|min:8',
                cpassword: 'required|min:8|same:password',
            })
            // recaptchaToken: "required",
        }

        const message = {
            'email.required': 'Email is Required.',
            'email.email': 'please enter valid email.',
            'first_name.required': 'First name is Required.',
            'last_name.required': 'Last name is Required.',
            'password.min': 'The password must contain a minimum of 8 characters.',
            'password.required': 'Password is Required.',
            'cpassword.required': 'Please enter password again.',
            'cpassword.same': 'Password and confirm password must be same.',
            'cpassword.min': 'Confirm password must contain a minimum of 8 characters.',
            'recaptchaToken.required': 'reCAPTCHA verification is required.',
            'legal_company_name.required': 'Company name is Required.',
            'other_provider_name.required': 'Provider name is required.',

        }

        validateAll(state, rules, message).then(async () => {

            const formaerrror = {};


            if (!isOtherProvider && !(strength >= 3)) {
                formaerrror['password'] = 'Please enter strong password'
            }

            if (!selectedTourProviderOption) {
                formaerrror['company_tour_provider'] = 'Please select a tour booking provider.'
            }


            if (phoneError != '') {
                formaerrror['country_code'] = phoneError
            }

            if (!countryCode && phone) {
                formaerrror['country_code'] = 'Please select country.'
            }

            setState({
                ...state,
                error: formaerrror
            })

            if (Object.keys(formaerrror).length) {
                return false;
            }

            // console.log('test')
            // return false


            setState({
                ...state,
                error: formaerrror
            })
            setIsLoading(true)

            let data = {}
            data.first_name = first_name
            data.last_name = last_name
            data.phone = phone
            data.email = email
            data.password = password
            data.country_code = countryCode
            data.legal_company_name = legal_company_name
            // data.company_country = selectedCountryOption.value
            data.company_country = selectedCountryOption
            data.tour_provider = selectedTourProviderOption
            if (isOtherProvider) {
                data.other_provider_name = other_provider_name
            }

            // data.recaptchaToken = recaptchaToken


            const authenticate = await ApiCall('post', 'register', data)

            if (authenticate) {
                if (authenticate.data.success) {
                    if (authenticate.data.status === 'integration_request') {
                        navigate(`/integration-requested?email=${encodeURIComponent(email)}&provider_name=${encodeURIComponent(other_provider_name)}`)
                    } else {
                        dispatch(setEmailVerified(false))

                        // ToastAlert({ msg: authenticate.data.message, msgType: 'success' });
                        // navigate('/login')

                        let dispatchData = {}
                        dispatchData.userDetails = authenticate.data.user
                        // dispatchData.token = authenticate.data.access_token
                        dispatchData.tempEmail = authenticate.data.user.email
                        dispatch(setLogin(dispatchData))
                        setIsLoading(false)
                        ToastAlert({ msg: authenticate.data.message, msgType: 'success' });
                        navigate('/verify')
                    }

                } else {

                    if (authenticate.data.errors && Object.keys(authenticate.data.errors).length) {

                        setState({
                            ...state,
                            error: authenticate.data.errors,
                        })

                    } else {
                        ToastAlert({ msg: authenticate.data.message, msgType: 'error' });
                    }
                    setIsLoading(false)

                }
            } else {
                setIsLoading(false)
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }

        }).catch(errors => {
            setIsLoading(false)
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }
            // if (!countryCode && phone) {
            //     formaerrror['countryCode'] = 'Please select country.'
            // }

            setState({
                ...state,
                error: formaerrror,
            })

        });

    }

    const changeValue = (e) => {

        let value = e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        })
        if (e.target.name == 'password') {
            checkStrength(value);
            if (value && cpassword && value === cpassword) {
                setIsSamePass(true)
            } else {
                setIsSamePass(false)
            }
        }
        if (e.target.name == 'cpassword') {
            if (password && value === password) {
                setIsSamePass(true)
            } else {
                setIsSamePass(false)
            }

        }
    }

    const handhandleShowPassword = (e, type) => {
        e?.preventDefault();
        if (type == 1) {
            setShowPassword(!showPassword)
        } else {
            setShowCPassword(!showCPassword)

        }
    }

    const setRecaptchaToken = (token) => {
        setState({
            ...state,
            recaptchaToken: token
        })
    }

    const handleNumberChange = (e) => {
        setPhone(e)
        const instance = inputRef?.current?.getInstance();
        let countryData = instance?.getSelectedCountryData();
        setCountryCode(countryData?.iso2)
    };

    const handleValidityChange = (isValid) => {
        if (phone) {
            if (!isValid) {
                setPhoneError('Invalid phone number')
            } else {
                setPhoneError('')

            }
        }
    };

    // useEffect(() => {
    // itiRef.current = IntlTelInput(inputRef.current, {
    //     utilsScript: utils,
    //     initialCountry: "auto",
    //     separateDialCode: true,
    //     geoIpLookup: callback => {
    //         fetch("https://ipapi.co/json")
    //             .then(res => res.json())
    //             .then(data => callback(data.country_code))
    //             .catch(() => callback("us"));
    //     },
    // });
    // inputRef.current.addEventListener('countrychange', function () {
    //     // setDialCode(iti.getSelectedCountryData().iso2);
    //     setState({
    //         ...state,
    //         countryCode:  itiRef.current.getSelectedCountryData().iso2
    //     })
    // });

    // return () => {
    //     if (itiRef.current) {
    //         itiRef.current.destroy();
    //     }
    // };

    // }, []);

    // const fetchUserCountry = async () => {
    //     try {
    //         const response = await fetch("https://api.ipify.org?format=json");
    //         const data = await response.json();
    //         const ip = data.ip;
    //         const geoResponse = await fetch(`https://ipapi.co/${ip}/country/`);
    //         const country_code = await geoResponse.text();

    //         setInitialCountry(country_code.toLowerCase()); // Set initial country
    //     } catch (error) {
    //         console.error("Error fetching IP or country:", error);
    //     }
    // };

    // useEffect(() => {
    //     (async () => {
    //         await fetchUserCountry();
    //     })();

    // }, []);

    const geoIpLookup = (success, failure) => {
        fetch("https://api.ipify.org?format=json")
            .then((response) => response.json())
            .then((data) => {
                const ip = data.ip;
                return fetch(`https://ipapi.co/${ip}/country/`);
            })
            .then((response) => response.text())
            .then((countryCode) => {
                success(countryCode.toLowerCase()); // Call success callback with ISO2 code
            })
            .catch(() => {
                failure();
            });
    }


    // useEffect(() => {
    //     if (inputRef.current) {
    //         const iti = inputRef.current.getInstance();
    //         iti.setCountry(initialCountry);
    //     }
    // }, [initialCountry]);


    const handleSearchCountry = (search) => {
        setIsLoadingCountry(true)
        const filteredCountries = CountrySelectoptions.filter(
            (country) => country.label.toLowerCase().includes(search.toLowerCase())
        );

        if (filteredCountries.length > 0) {
            setCountryOptions(filteredCountries)
        }
        setIsLoadingCountry(false)
    }

    const handleInputChangeSelect = (inputValue) => {
        if (inputValue.trim() !== "") {
            handleSearchCountry(inputValue);
        } else {
            setCountryOptions(CountrySelectoptions);
        }
    };

    const handleCountrySelectChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedCountryOption(selectedValue);
    }
    
    const handleTourProviderSelectChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedTourProviderOption(selectedValue);
    }

    return (
        <>
            <PageTitle title={'Signup'} />
            <Index
                state={state}
                register={register}
                changeValue={changeValue}
                showPassword={showPassword}
                showCPassword={showCPassword}
                handhandleShowPassword={handhandleShowPassword}
                inputRef={inputRef}
                getClassNames={getClassNames}
                setRecaptchaToken={setRecaptchaToken}
                isLoading={isLoading}
                handleNumberChange={handleNumberChange}
                handleValidityChange={handleValidityChange}
                initialCountry={initialCountry}
                geoIpLookup={geoIpLookup}
                isSamePass={isSamePass}
                selectedCountryOption={selectedCountryOption}
                selectedTourProviderOption={selectedTourProviderOption}
                isOtherProvider={isOtherProvider}
                isNoProvider={isNoProvider}
                countryOptions={countryOptions}
                handleInputChangeSelect={handleInputChangeSelect}
                handleCountrySelectChange={handleCountrySelectChange}
                handleTourProviderSelectChange={handleTourProviderSelectChange}
                isLoadingCountry={isLoadingCountry}
            />
        </>
    )

}